"use client";

import { Image as ImageIcon, Link as LinkIcon, Trash2 } from "lucide-react";
import React from "react";
import type { SelectionState } from "../types";

interface ImageToolbarProps {
  selectionState: SelectionState;
  onOpenImageLinkModal: () => void;
  onRemoveImageLink: () => void;
}

export const ImageToolbar: React.FC<ImageToolbarProps> = ({
  selectionState,
  onOpenImageLinkModal,
  onRemoveImageLink,
}) => {
  if (!selectionState.isImageSelected) return null;

  return (
    <div className="flex flex-wrap gap-2 p-2 border-b bg-gradient-to-r from-green-50 to-emerald-50 items-center">
      <span className="text-sm font-semibold text-gray-700 flex items-center gap-1">
        <ImageIcon className="w-4 h-4" />
        Image Tools:
      </span>

      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onOpenImageLinkModal();
        }}
        className={`px-2 py-1 text-xs border rounded bg-white hover:bg-blue-50 flex items-center gap-1 ${
          selectionState.currentImageLink
            ? "border-blue-400 text-blue-600"
            : "border-gray-300 text-gray-600"
        }`}
        title="Add/Edit Image Link"
      >
        <LinkIcon className="w-3 h-3" />
        {selectionState.currentImageLink ? "Edit Link" : "Add Link"}
      </button>

      {selectionState.currentImageLink && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemoveImageLink();
          }}
          className="px-2 py-1 text-xs border border-red-300 rounded bg-white hover:bg-red-50 text-red-600 flex items-center gap-1"
          title="Remove Image Link"
        >
          <Trash2 className="w-3 h-3" />
          Remove Link
        </button>
      )}

      <span className="text-xs text-gray-500 ml-2">
        {selectionState.currentImageLink && (
          <>
            Current:{" "}
            <a
              href={selectionState.currentImageLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 underline max-w-[200px] truncate inline-block align-bottom"
            >
              {selectionState.currentImageLink}
            </a>
          </>
        )}
      </span>
    </div>
  );
};
